module.exports = __webpack_public_path__ + "img/3.695bd7a5.jpg";